import AppCopy from "../AppComponents/AppCopy";

const CopyGroup = ({ name, description, link }: { [key: string]: string }) => {
  return (
    <div className="my-4">
      <h4 className="mb-0">{name}</h4>
      <p className="small mb-1">{description}</p>
      <div className="d-flex mb align-items-center">
        <a
          className="border rounded text-truncate p-1 mr-2 text-sm"
          href={link}
          rel="noopener noreferrer"
          target="_blank"
        >
          {link}
        </a>
        <AppCopy text={link} />
      </div>
    </div>
  );
};

export default CopyGroup;
